import { render, staticRenderFns } from "./WindowScrollDetector.vue?vue&type=template&id=65fa5e9e&"
import script from "./WindowScrollDetector.vue?vue&type=script&lang=js&"
export * from "./WindowScrollDetector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports